import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../signUp/signup.css"; // Importing the stylesheet

export default function Signup() {
    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        birthdate: "",
        password: "",
        confirmPassword: "",
        agreedToTerms: false,
    });

    const [status, setStatus] = useState("");
    const navigate = useNavigate();

    const passwordRules = {
        length: form.password.length >= 8 && form.password.length <= 24,
        uppercase: /[A-Z]/.test(form.password),
        number: /\d/.test(form.password),
    };

    const passedRules = Object.values(passwordRules).filter(Boolean).length;
    const strengthLabel = ["Weak", "Medium", "Strong"][passedRules - 1] || "Weak";
    const strengthColor = ["red", "orange", "green"][passedRules - 1] || "red";
    const isPasswordValid = passedRules === 3;

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handlePhoneChange = (e) => {
        let value = e.target.value.replace(/\D/g, ""); // Strip non-digits

        if (value.length > 10) value = value.slice(0, 10);

        if (value.length > 6) {
            value = value.replace(/(\d{3})(\d{3})(\d{0,4})/, "$1-$2-$3");
        } else if (value.length > 3) {
            value = value.replace(/(\d{3})(\d{0,3})/, "$1-$2");
        }

        setForm((prev) => ({
            ...prev,
            phone: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!isPasswordValid) {
            setStatus("❌ Password does not meet all requirements.");
            return;
        }

        if (form.password !== form.confirmPassword) {
            setStatus("❌ Passwords do not match.");
            return;
        }

        if (!form.agreedToTerms) {
            setStatus("❌ You must agree to the Terms and Privacy Policy.");
            return;
        }

        try {
            const res = await fetch("http://localhost:4000/api/signup", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    firstName: form.firstName,
                    lastName: form.lastName,
                    email: form.email,
                    phone: form.phone ? `+1-${form.phone}` : null,
                    birthdate: form.birthdate,
                    password: form.password,
                }),
            });

            if (res.ok) {
                navigate("/login");
            } else {
                const data = await res.json();
                setStatus(`❌ Signup failed: ${data.error || "Something went wrong"}`);
            }
        } catch (err) {
            console.error(err);
            setStatus("❌ Signup failed: Network or server error.");
        }
    };

    const renderRule = (label, passed) => (
        <li className={`rule ${passed ? "passed" : "failed"}`}>
            {passed ? "✅" : "❌"} {label}
        </li>
    );

    return (
        <div className="signup-page">
            <div className="signup-container">
                <h2 className="signup-title">
                    Create an Account
                    <span className="kanji-subtitle">🌸 桜の会員登録 🌸</span>
                </h2>

                <form className="signup-form" onSubmit={handleSubmit}>
                    <div className="field-row">
                        <div>
                            <label>First Name:</label>
                            <input name="firstName" value={form.firstName} onChange={handleChange} required />
                        </div>
                        <div>
                            <label>Last Name:</label>
                            <input name="lastName" value={form.lastName} onChange={handleChange} required />
                        </div>
                    </div>

                    <div className="field-row">
                        <div>
                            <label>Email:</label>
                            <input name="email" type="email" value={form.email} onChange={handleChange} required />
                        </div>
                        <div>
                            <label>Phone (optional):</label>
                            <input
                                name="phone"
                                type="tel"
                                value={form.phone}
                                onChange={handlePhoneChange}
                                placeholder="e.g. 123-456-7890"
                            />
                        </div>
                    </div>

                    <div className="field-row">
                        <div>
                            <label>Password:</label>
                            <input name="password" type="password" value={form.password} onChange={handleChange} required />
                        </div>
                        <div>
                            <label>Confirm Password:</label>
                            <input name="confirmPassword" type="password" value={form.confirmPassword} onChange={handleChange} required />
                        </div>
                    </div>

                    <div className="field-row">
                        <div>
                            <label>Birthdate (optional):</label>
                            <input name="birthdate" type="date" value={form.birthdate} onChange={handleChange} />
                        </div>
                    </div>

                    <div className="strength-bar">
                        <div className="bar-track">
                            <div className="bar-fill" style={{ width: `${(passedRules / 3) * 100}%`, backgroundColor: strengthColor }} />
                        </div>
                        <small className={`strength-text ${strengthColor}`}>Password Strength: {strengthLabel}</small>
                    </div>

                    <ul className="password-rules">
                        {renderRule("8–24 characters", passwordRules.length)}
                        {renderRule("At least one uppercase letter", passwordRules.uppercase)}
                        {renderRule("At least one number", passwordRules.number)}
                    </ul>

                    <div className="terms-checkbox">
                        <input type="checkbox" name="agreedToTerms" checked={form.agreedToTerms} onChange={handleChange} required />
                        <label>I agree to the <a href="/terms" target="_blank" rel="noopener noreferrer">Terms</a> & <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></label>
                    </div>

                    <button type="submit" className="signup-button">Sign Up</button>
                    <div className="form-footer">
                        <span>Already have an account? <a href="/login">Log in here</a></span>
                    </div>

                </form>

                {status && <p className="signup-status">{status}</p>}
            </div>
        </div>
    );
}